import FullscreenApi from '../Classes/FullscreenApi.js';

const extended = new WeakSet;

// the function that does the extension is part of the module
export default function extendVideoJS(videojs)
{
	// don't extend videojs if it has already been extended
	if(extended.has(videojs))
	{
		return;
	}
	extended.add(videojs);

	videojs.log.history.disable();

	// noinspection JSUnresolvedFunction
	const Component = videojs.getComponent('Component');
	// noinspection JSUnresolvedFunction
	const Button = videojs.getComponent('Button');

	let fullscreenApi;

	class FullscreenToggle extends Button
	{
		constructor(player, options)
		{
			super(player, options);

			fullscreenApi = new FullscreenApi(options.playerOptions.fullscreenElement);

			fullscreenApi.addEventListener
			(
				'fullscreenchange',
				() =>
				{
					if (fullscreenApi.isFullscreen)
					{
						// noinspection JSUnresolvedFunction
						this.controlText('Non-Fullscreen');
						player.isFullscreen(true);
					}
					else
					{
						// noinspection JSUnresolvedFunction
						this.controlText('Fullscreen');
						player.isFullscreen(false);
					}
				}
			);

			if (!fullscreenApi.fullscreenEnabled)
			{
				this.disable();
			}

			this.on
			(
				'unmute',
				event =>
				{
					if(fullscreenApi.isFullscreen)
					{
						event.stopPropagation();
					}
				}
			);
		}

		// noinspection JSUnusedGlobalSymbols
		buildCSSClass()
		{
			// noinspection JSUnresolvedFunction
			return `vjs-fullscreen-control ${super.buildCSSClass()}`;
		}

		// noinspection JSMethodCanBeStatic,JSUnusedGlobalSymbols
		handleClick()
		{
			if (fullscreenApi.isFullscreen)
			{
				fullscreenApi.exitFullscreen();
			}
			else
			{
				fullscreenApi.requestFullscreen();
			}
		}
	}

	// noinspection JSUnusedGlobalSymbols
	FullscreenToggle.prototype.controlText_ = 'Fullscreen';

	// noinspection JSUnresolvedFunction
	Component.registerComponent('FullscreenToggle', FullscreenToggle);
}